import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { item } from "./types";
import React, { useEffect, useState } from "react";
import PrismaticBurst from "../PrismaticBurst";

type props = {
  drink: item;
  key: number;
};

const DrinksListItem = (props: props) => {
  const sponsorImgSrc = `assets/sponsorImg/${props.drink.menuNum}.png`;
  const imgPath = `/assets/drinkImg/${props.drink.menuNum}.png`;
  const [cardState, setCardState] = useState<string>("");

  useEffect(() => {
    if (props.drink.highlight == 0) {
    } else if (props.drink.highlight == 1) {
      setCardState("#777777");
    } else if (props.drink.highlight == 2) {
      setCardState("#fffb00");
    }
  }, [props.drink]);

  return (
    <Card
      className={props.drink.highlight == 2 ? "selectedDrink" : "defaultDrink"}
      style={{
        width: props.drink.highlight == 2 ? "20%" : "14%",
        backgroundColor:
          props.drink.highlight == 1
            ? "#777777"
            : props.drink.highlight == 2
            ? ""
            : "",
      }}
    >
      <Container>
        <Row>
          <Col>
            {/* <div style={{fontSize: "25px"}}>{props.drink.menuNum}. {props.drink.title} <b style={{ paddingLeft: "20px" }}>ABV:</b> {props.drink.abv} </div> */}
              {props.drink.menuNum}. {props.drink.title}{" "}
          </Col>
          <Col xs="auto">
            <Image
              src={imgPath}
              style={{
                transition: "2s",
                maxHeight: props.drink.highlight == 2 ? "350px": "120px",
                borderRadius: "10px",
                padding: "8px",
              }}
            />
          </Col>
        </Row>
      </Container>
    </Card>
  );
};

export default DrinksListItem;
